import { render } from "./HiAddressDisplay.vue?vue&type=template&id=26d8827c"
import script from "./HiAddressDisplay.vue?vue&type=script&lang=js"
export * from "./HiAddressDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__